import MenuSection from "../MenuSection.js";
import React, { useMemo } from "react";
import { MenuItemFactory } from "../MenuItemFactory.js";
import { useMobileCategories } from "./hooks/useMobileCategories.js";

const CategoriesMobile = () => {
  const menuItems = useMobileCategories();
  const components = useMemo(
    () =>
      menuItems?.map(menuItem => (
        <MenuItemFactory
          key={menuItem.key}
          componentProps={menuItem.props}
          componentType={menuItem.componentType}
        />
      )),
    [menuItems]
  );
  return <MenuSection className="categoriesSection">{components}</MenuSection>;
};

export default React.memo(CategoriesMobile);
